<template>
  <filter-state-field-inner
    :key="name"
    :name="name"
    :invisible="invisible"
    :default-value="defaultValue"
  >
    <template #default="{ value, onChange }">
      <slot
        :value="value"
        :on-change="onChange"
      />
    </template>
  </filter-state-field-inner>
</template>

<script>
import { defineComponent } from 'vue';
import FilterStateFieldInner from './filter-state-field-inner.vue';

export default defineComponent({
  name: 'FilterStateField',
  components: { FilterStateFieldInner },
  props: FilterStateFieldInner.props
});
</script>

<i18n lang="json">{}</i18n>
